import React from 'react';
import {
  Stack, Text, UnorderedList, useTranslation,
} from '@piwikpro/ui-components';

export const SamlTurnOffModal = () => {
  const { t } : { t: (key: string) => string } = useTranslation();

  return (
    <Stack spacing="narrow" vertical>
      <Stack.Item>
        <Text as="p">{t('administration:accountSecurity.saml-turn-off.modal.message')}</Text>
      </Stack.Item>
      <Stack.Item previousSpacing="none">
        <UnorderedList>
          <UnorderedList.Item>
            <Text as="p">{t('administration:accountSecurity.saml-turn-off.modal.line1')}</Text>
          </UnorderedList.Item>
          <UnorderedList.Item>
            <Text as="p">{t('administration:accountSecurity.saml-turn-off.modal.line2')}</Text>
          </UnorderedList.Item>
          <UnorderedList.Item>
            <Text as="p">{t('administration:accountSecurity.saml-turn-off.modal.line3')}</Text>
          </UnorderedList.Item>
        </UnorderedList>
      </Stack.Item>
      <Stack.Item>
        <Text as="p">{t('administration:accountSecurity.saml-turn-off.modal.question')}</Text>
      </Stack.Item>
    </Stack>
  );
};
